import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// PWA service worker — DISABLED 2026-02 (was caching old JS chunks even
// after a clean redeploy; users had to manually unregister via DevTools).
// Calling `unregister()` actively tears down any SW already installed in
// returning visitors' browsers, then doesn't install a new one. Re-enable
// only when we have a versioned-cache strategy (Workbox / `skipWaiting`).
serviceWorkerRegistration.unregister();
